import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Tabs, UIKits } from "../../../Constants/Constants";
import BorderTabs from "./BorderTabs";
import IconTabs from "./IconTabs";
import JustifyTab from "./JustifyTab";
import MaterialLeftStyleTab from "./MaterialLeftStyleTab";
import MaterialStyleTab from "./MaterialStyleTab";
import PillsTab from "./PillsTab";
import SimpleTab from "./SimpleTab";
import VerticalTab from "./VerticalTab";

const TabsContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Tabs} parent={UIKits} />
      <Container fluid>
        <Row>
          <SimpleTab />
          <IconTabs />
          <VerticalTab />
          <PillsTab />
          <JustifyTab />
          <MaterialLeftStyleTab />
          <MaterialStyleTab />
          <BorderTabs />
        </Row>
      </Container>
    </>
  );
};
export default TabsContainer;
